/* 项目管理-API */

import {post,get} from '../../libs/ajax.js'

export default {
    // 账户列表
    getDataList:(data,options) => {
        return get('/project_manage/get_list', data, options);
    },
    getOperatorList(data,options){
        return get('/project_manage/get_creator_or_integrator_list', data, options);
    },
    // 添加项目
    addProject:(data,options) => {
        return post('/project_manage/add_project', data, options);
    },
    // 删除项目
    deleteProject:(data,options) => {
        return post('/project_manage/del_project', data, options);
    },
    // 编辑项目
    editProject:(data,options) => {
        return post('/project_manage/edit_project', data, options);
    },
    // 编辑推广内容
    editSubProject:(data,options) => {
        return post('/project_manage/edit_subproject_pid', data, options);
    },
    // 获取 /td/api/project_manage/get_project_list
    getProjectList:(data,options) => {
        return get('/project_manage/get_project_list', data, options);
    },
    // 导出
    exportOperatorList(data,options){
        return get('/project_manage/export', data, options);
    },
}
